module.exports = __webpack_public_path__ + "img/bookings.b682636e.jpg";